/**
 * SearchInput
 *
 */

import React, { useEffect, useState } from 'react'
import { Box, IconButton, InputAdornment, Popover, TextField, Theme, useMediaQuery, useTheme } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { makeStyles } from '@mui/styles'
import * as settingsActions from '../../store/settings/settings.actions'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

interface Props {
  disabled?: boolean
  value?: string
  changeSearch?: (searchInput: string | undefined) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  search: {
    margin: 0,
    color: theme.palette.primary.main,
  },
}))

const SearchComponent: React.FC<Props> = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const theme: Theme = useTheme()
  const downXl = useMediaQuery(theme.breakpoints.down('xl'))

  const [searchInput, setSearchInput] = useState<string | undefined>(props.value)
  const disabled = props.disabled ? props.disabled : false

  useEffect(() => {
    props.changeSearch && props.changeSearch(searchInput)
  },
  [searchInput],
  )

  useEffect(() => {
    setSearchInput(props.value)
  },
  [props.value],
  )

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)

  const SearchInput = () => {
    return (
      <TextField
        className={classes.search}
        disabled={disabled}
        id='search'
        autoFocus
        label='Suchen'
        name='name'
        sx={{
          width: '280px',
          mb: '1rem',
          '& label.Mui-focused': {
            color: theme.palette.primary.main,
          },
          '& label': {
            color: theme.palette.primary.main,
          },
          '& .MuiInputBase-root': {
            color: theme.palette.primary.main,
            '& > fieldset': {
              borderColor: theme.palette.primary.main,
            },
            '&:hover fieldset': {
              borderColor: theme.palette.primary.main,
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
            },
          },
        }}
        InputProps={{
          style: { color: `${theme.palette.primary.main}!important` },
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon
                onClick={() => {
                  const actualPath = history.location.pathname
                  actualPath !== '/searchResults' && history.push('/searchresults')
                  dispatch(settingsActions.setNavPoint([]))
                }} sx={{ color: theme.palette.primary.main, cursor: 'pointer' }}
              />
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(event => {
          setSearchInput(event.target.value)
        })}
        size='small'
        value={searchInput}
      />
    )
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        display: 'flex',
        top: '0px',
        left: '0px',
        padding: '20px',
        color: '#fff',
      }}
    >
      {downXl
        ? (
          <>
            <IconButton sx={{ position: 'relative' }} onClick={handleClick}>
              <SearchIcon sx={{ color: '#fff' }} />
              <Box
                sx={searchInput ? {
                  borderRadius: '10px',
                  width: '15px',
                  height: '15px',
                  backgroundColor: theme.palette.primary.dark,
                  color: '#fff',
                  position: 'absolute',
                  top: '5px',
                  right: '5px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                } : {
                  width: '15px',
                  height: '15px',
                  color: 'transparent',
                }}
              >
                !
              </Box>
            </IconButton>
            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <Box sx={{ padding: '24px' }}>
                {SearchInput()}
              </Box>
            </Popover>
          </>)
        : (
          <>
            {SearchInput()}
          </>)}
    </Box>
  )
}

export default SearchComponent
